/**
 * @property {number} cycle
 * @property {number} purchase
 */
export class Price {
  /**
   *
   * @param {number|null} cycle
   * @param {number|null} purchase
   */
  constructor(cycle = null, purchase = null) {
    this.cycle = cycle;
    this.purchase = purchase;
  }

  /**
   *
   * @return {boolean}
   */
  get hasCycle() {
    return this.cycle !== null;
  }

  /**
   *
   * @return {boolean}
   */
  get hasPurchase() {
    return this.purchase !== null;
  }

  /**
   * Returns, if exists at least one non null price value.
   *
   * @return {boolean}
   */
  get exists() {
    return this.hasCycle || this.hasPurchase;
  }

  /**
   * Returns if price is equal to other price.
   *
   * @param {Price} price
   * @return {boolean}
   */
  isEqual(price) {
    return price && price.cycle === this.cycle && price.purchase === this.purchase;
  }
}
